import { render } from "./Withdrawals.vue?vue&type=template&id=ed090640&ts=true"
import script from "./Withdrawals.vue?vue&type=script&lang=ts"
export * from "./Withdrawals.vue?vue&type=script&lang=ts"

import "./Withdrawals.vue?vue&type=style&index=0&id=ed090640&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__